import React from 'react'
import VisaImg from '../../../assets/icons/visa-icon.png'
import VisaImgPb from '../../../assets/icons/visa-icon-pb.png'
import { StyledIcon } from './styled-icon.style'

/**
 * @param {boolean} disabled
 * if true, set the img to black and white
 */
const VisaIcon = ({ disabled, className }) => (
	<StyledIcon className={className}>
		<img src={disabled ? VisaImgPb : VisaImg} alt="Logo Visa" />
	</StyledIcon>
)

export default VisaIcon
